import { swipeBehavior } from '@tma.js/sdk-vue';

/**
 * Telegram collapses or closes a Mini App on a vertical swipe, so the slightest scroll on a
 * list could drag the whole wallet down. The swipe is switched off for the app's whole lifetime
 * (the same choice BotFather's own Mini App makes); the header close button still works, and
 * the in-app bottom sheet keeps its own drag-to-close gesture. Best effort: clients below
 * Bot API 7.7 have no swipe behaviour control and `ifAvailable` is a no-op there.
 */
export function disableTelegramVerticalSwipe(): void {
  try {
    swipeBehavior.mount.ifAvailable();
    swipeBehavior.disableVertical.ifAvailable();
  } catch (error) {
    console.error('Failed to switch off the Telegram vertical swipe.', error);
  }
}
